export const localStorageRecipientName = 'recipient-name'
